module.exports = Turbolinks;